module.exports = __webpack_public_path__ + "img/23_113.83727dd1.png";